import type { FC } from 'react';
import s from './index.module.scss';
import { Header } from './header';
import { Footer } from './footer';

type Layout = FC<{
  component: FC;
}>;
export const Layout: Layout = (p) => {
  const Component = p.component;

  return (
    <div className={s.layout}>
      <Header />

      <main className={s.content}>
        <Component />
      </main>

      <Footer />
    </div>
  );
};
